import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ViewRef,
} from '@angular/core';
import { merge, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CpInput } from './input.directive';
import { CpLabel } from './label.directive';
import { CpSelect } from './select.directive';
import { CpSuffix } from './suffix.directive';

@Component({
  selector: 'cp-form-field',
  templateUrl: './form-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpFormFieldComponent implements AfterContentInit {
  @ContentChild(CpInput)
  _input: CpInput;

  @ContentChild(CpSelect)
  _select: CpSelect;

  @ContentChild(CpLabel)
  _label: CpLabel;

  @ContentChild(CpSuffix)
  _suffix: CpSuffix;

  @ViewChild('inputRef') inputRef: ElementRef;
  @ViewChild('selectRef') selectRef: ElementRef;
  isError$: Observable<boolean>;
  shouldFloat$: Observable<boolean>;
  shouldFloat: boolean;
  @Input() isAltTheme = false;
  @Input() isComboTheme = false;

  outline = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngAfterContentInit() {
    const changes$ = merge(
      this.input.control.valueChanges,
      this.input.control.statusChanges,
      this.input.stateChanges
    ).pipe(startWith(true));

    // hack to keep keep the cp-box theme running correctly and not having a label that moves.
    setTimeout(() => {
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    }, 10);

    this.isError$ = changes$.pipe(map(() => this.input.control.invalid && this.input.control.touched));
    this.shouldFloat$ = changes$.pipe(map(() => this.input.focus || this.hasValue() || !!this.input.placeholder));

    this.shouldFloat$.subscribe((floatFlag) => {
      this.shouldFloat = floatFlag;
    });
  }

  hasInputInFormField() {
    if (this.inputRef) {
      if (this.inputRef.nativeElement.childNodes.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  hasSelectInFormField() {
    if (this.selectRef) {
      if (this.selectRef.nativeElement.childNodes.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  isNormalTheme() {
    return this.isAltTheme === false ? true : false;
  }

  shouldLabelFloat() {
    return this.isAltTheme === false && this.shouldFloat === true ? true : false;
  }

  private hasValue(): boolean {
    const { value } = this.input.control;
    return !(value === null || value === undefined || value === '');
  }

  private get input() {
    return this._input || this._select;
  }
}
